import { Box, Stack, Typography } from '@mui/material';
import { colors } from './landingTheme';
import { features, screenRows } from './landingData';

const DeviceShowcase = () => (
    <Box
        sx={{
            position: 'relative',
            width: '100%',
            maxWidth: 920,
            mx: 'auto',
            mt: { xs: 4, md: 6 },
            minHeight: { xs: 360, sm: 430, md: 520 },
        }}
    >
        <Box
            sx={{
                position: 'absolute',
                left: '50%',
                top: { xs: 12, md: 0 },
                transform: 'translateX(-50%)',
                width: { xs: 270, sm: 320, md: 380 },
                borderRadius: '42px',
                p: 1.2,
                bgcolor: '#020617',
                boxShadow: '0 30px 80px rgba(0,0,0,0.55)',
                border: '1px solid rgba(148, 163, 184, 0.25)',
                zIndex: 2,
            }}
        >
            <Box
                sx={{
                    borderRadius: '34px',
                    overflow: 'hidden',
                    bgcolor: colors.dark,
                    color: colors.textLight,
                    p: { xs: 2, md: 2.4 },
                }}
            >
                <Stack spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Box>
                            <Typography sx={{ color: colors.blueLight, fontSize: '0.74rem', fontWeight: 700 }}>
                                HEUTE
                            </Typography>
                            <Typography sx={{ fontWeight: 800, fontSize: '1.35rem' }}>Push Training</Typography>
                        </Box>
                        <Box
                            sx={{
                                px: 1.2,
                                py: 0.6,
                                borderRadius: 999,
                                bgcolor: 'rgba(52, 211, 153, 0.16)',
                                color: colors.green,
                                fontWeight: 800,
                                fontSize: '0.82rem',
                            }}
                        >
                            72%
                        </Box>
                    </Stack>

                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
                        {[
                            ['5', 'Übungen'],
                            ['18', 'Sätze'],
                            ['48', 'Min'],
                        ].map(([value, label]) => (
                            <Box key={label} sx={{ p: 1.2, borderRadius: 2, bgcolor: 'rgba(255,255,255,0.07)' }}>
                                <Typography sx={{ fontWeight: 900, fontSize: '1.2rem' }}>{value}</Typography>
                                <Typography sx={{ color: colors.blueLight, fontSize: '0.72rem' }}>{label}</Typography>
                            </Box>
                        ))}
                    </Box>

                    <Stack spacing={1}>
                        {screenRows.map((row) => (
                            <Stack
                                key={row.name}
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{
                                    p: 1.2,
                                    borderRadius: 2,
                                    bgcolor: 'rgba(255,255,255,0.07)',
                                }}
                            >
                                <Box>
                                    <Typography sx={{ fontWeight: 800, fontSize: '0.92rem' }}>{row.name}</Typography>
                                    <Typography sx={{ color: colors.blueLight, fontSize: '0.74rem' }}>Bestwert</Typography>
                                </Box>
                                <Box sx={{ textAlign: 'right' }}>
                                    <Typography sx={{ fontWeight: 900, fontSize: '0.92rem' }}>{row.value}</Typography>
                                    <Typography sx={{ color: colors.green, fontSize: '0.74rem', fontWeight: 800 }}>{row.trend}</Typography>
                                </Box>
                            </Stack>
                        ))}
                    </Stack>
                </Stack>
            </Box>
        </Box>

        <Box
            sx={{
                position: 'absolute',
                left: { xs: '50%', md: 0 },
                right: { md: 0 },
                bottom: { xs: 0, md: 10 },
                transform: { xs: 'translateX(-50%)', md: 'none' },
                width: { xs: 330, sm: 470, md: '100%' },
                height: { xs: 190, sm: 230, md: 285 },
                borderRadius: { xs: 4, md: 5 },
                bgcolor: 'rgba(30, 41, 59, 0.7)',
                border: '1px solid',
                borderColor: colors.line,
                zIndex: 1,
                display: 'grid',
                gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr)' },
                gap: 1,
                p: { xs: 1.4, md: 2 },
            }}
        >
            {features.map((feature) => (
                <Box
                    key={feature.title}
                    sx={{
                        borderRadius: 3,
                        bgcolor: 'rgba(15, 23, 42, 0.72)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: feature.tone,
                    }}
                >
                    {feature.icon}
                </Box>
            ))}
        </Box>
    </Box>
);

export default DeviceShowcase;
